import styled from 'styled-components'

import { COLOR } from 'styles/constants'

export const CategoryIcon = styled.i`
  color: ${COLOR.BLUE_LV5};
  width: 20px;
  margin-right: 10px;
`

export const CategoryName = styled.span`
  color: ${COLOR.GREY_LV1};
  font-size: 14px;
  text-align: left;
  text-transform: capitalize;
`

export const CategoryItem = styled.button`
  padding: 10px;
  padding-right: 15px;
  margin-bottom: 8px;
  width: 100%;
  height: 50px;
  border-radius: 5px;
  border: solid 1px ${COLOR.GREY_LV4};
  background-color: ${COLOR.WHITE};
  transition: all 0.3s ease-in-out;
  display: flex;
  align-items: center;

  ${CategoryName} {
    flex-grow: 1;
  }

  &:hover {
    background-color: #f1f2f2;
  }

  &.active {
    background-color: #f3f9ff;
    border-color: #195db8;

    ${CategoryName} {
      font-weight: 600;
    }
  }
`
